import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  activeProduct: state.product.activeProduct,
});

angular
  .module('myConsultApp')
  .controller('productViewController', ($ngRedux, $rootScope, $scope) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.close = () => {
      $scope.setProduct(null);
      $rootScope.closeComponent();
    };

    $scope.$watch('activeProduct', () => {
      if ($scope.activeProduct) {
        $scope.title = 'VIEW PRODUCT';
        $scope.currentProduct = angular.copy($scope.activeProduct);
      }
    });

    $scope.init();
    $scope.$on('$destroy', $scope.unsubscribe);
  })
  .directive('productView', () => {
    return {
      templateUrl: 'templates/v2/product-view.html',
    };
  });
